import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EmailserviceService } from '../emailservice.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule]
})
export class ContactUsComponent implements OnInit {
  contactForm: FormGroup;
  isSubmitting: boolean = false;
  statusMessage: string = '';
  statusType: 'success' | 'error' | '' = '';

  inquiryTypes: string[] = [
    'Sales Inquiry',
    'General Inquiry',
    'Careers',
    'Support',
    'Grievance',
    'Other'
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private candidateService: EmailserviceService
  ) {
    this.contactForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^(\+91[\s-]?)?[6-9]\d{9}$/)]],
      company: ['', Validators.required],
      inquiryType: ['Sales Inquiry', Validators.required],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit(): void { }

  onSubmit(): void {
    if (this.contactForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      this.statusMessage = '';

      const contactData = {
        recipientEmail: 'rakshita.i@navriti.com',
        subject: `New Contact Inquiry (${this.contactForm.value.inquiryType}): ${this.contactForm.value.fullName.trim()}`,
        name: this.contactForm.value.fullName.trim(),
        email: this.contactForm.value.email.trim(),
        phone: this.contactForm.value.phone.trim(),
        company: this.contactForm.value.company.trim(),
        inquiryType: this.contactForm.value.inquiryType,
        message: this.contactForm.value.message.trim(),
        htmlTemplate: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #d1faee; border-radius: 12px; padding: 24px; background-color: #ffffff;">
            <div style="background-color: #01AF67; padding: 16px; border-radius: 8px; text-align: center;">
              <h2 style="color: #ffffff; margin: 0;">New Contact Inquiry - Certiplate</h2>
            </div>
            <div style="padding: 20px 0; color: #334155;">
              <p><strong>Inquiry Type:</strong> ${this.contactForm.value.inquiryType}</p>
              <p><strong>Full Name:</strong> ${this.contactForm.value.fullName.trim()}</p>
              <p><strong>Email:</strong> ${this.contactForm.value.email.trim()}</p>
              <p><strong>Phone Number:</strong> ${this.contactForm.value.phone.trim()}</p>
              <p><strong>Company:</strong> ${this.contactForm.value.company.trim()}</p>
              <p><strong>Message:</strong></p>
              <div style="background: #f8faf9; border-left: 4px solid #01AF67; padding: 12px; border-radius: 4px;">
                ${this.contactForm.value.message.trim()}
              </div>
            </div>
            <div style="border-top: 1px solid #e2e8f0; padding-top: 12px; font-size: 12px; color: #94a3b8; text-align: center;">
              This inquiry was submitted via the Certiplate Contact Us page.
            </div>
          </div>
        `
      };

      this.candidateService.sendContactMessage(contactData).subscribe({
        next: () => {
          this.statusMessage = 'Your message has been sent successfully! Our team will get back to you shortly.';
          this.statusType = 'success';
          this.isSubmitting = false;
          this.contactForm.reset({ inquiryType: 'Sales Inquiry' });
        },
        error: (err) => {
          console.error('Error sending contact message', err);
          this.statusMessage = 'Error sending message. Please try again.';
          this.statusType = 'error';
          this.isSubmitting = false;
        }
      });
    } else {
      this.contactForm.markAllAsTouched();
    }
  }

  goBackHome(): void {
    this.router.navigate(['/']);
  }
}
